(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-footer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-fb-share-url]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(btn.dataset.fbShareUrl);
      window.open(url, 'fb-share', 'width=600,height=500,resizable=yes,scrollbars=yes');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
